import list from "@/pages/message/list";
import AddNewMessage from "@/pages/message/AddNewMessage.vue";
import SendMessageList from "@/pages/message/SendMessageList.vue";


const routes = [
  {
    path: "/Message/Manage",
    component: list,
    meta: {requiredAuth: true},
  },
  {
    path: "/Message/addNew",
    component: AddNewMessage,
    meta: {requiredAuth: true},
  },
  {
    path: "/message/sendList",
    component: SendMessageList,
    meta: {requiredAuth: true},
  },
]

export default routes